angular.module('impactx.cscontract').controller('CSContractListCtrl', ['selectedListItems', '$mdDialog', '$redirect', '$routeParams', CSContractListCtrl]);

function CSContractListCtrl(selectedListItems, $mdDialog, $redirect, $routeParams) {

    this.createContract = function(event, actionLabel, trns) {
        $mdDialog.show({
            controller: "ContractCompanySelectionDialogCtrl",
            controllerAs: "contractCompanySelectionDialogCtrl",
            templateUrl: "modules/cscontract/templates/cscontracompanyselection.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                headerLabel: actionLabel,
                cscId: null
            }
        })
            .then(function(answer)
            {
                $redirect.redirectTo(null, "contract/0/" + answer.type + "/" + answer.buyerComId + "/" +
                    answer.supplierComId + "/" + answer.contactBuyerId + "/" + answer.catalogId + "/" + answer.masterContractId + "/" + answer.isModelContract)
            }, function() {
            });
    };
    var self = this;

    this.getMainDataLink = function() {
        return self.buildRoute("cscmain/");
    };

    this.getSettingsDataLink = function() {
        return self.buildRoute("cscsettings/");
    };

    this.getAccountingLink = function() {
        return self.buildRoute("cscaccounting/");
    };

    this.getCSCNumberingSchemaLink = function() {
        return self.buildRoute("cscnumberingschemas/");
    };

    this.getCSCOutletLink = function() {
        return self.buildRoute("cscoutlets/");
    };

    this.getCSCBudgetsLink = function() {
        return self.buildRoute("cscbudgets/");
    };

    this.getCSCAddressesLink = function() {
        return self.buildRoute("cscaddresses/");
    };

    this.getCSCOrdersLink = function() {
        return self.buildRoute("cscorders/");
    };

    this.getCSCCommentsLink = function() {
        return self.buildRoute("csccomments/");
    };

    this.getConditionsDataLink = function() {
        return self.buildRoute("cscconditions/");
    };

    this.getRFQCDataLink = function() {
        return self.buildRoute("cscrfqc/");
    };

    this.getCSCToleranceLink = function() {
        return self.buildRoute("csctolerance/");
    };

    this.getCSCGrnLink = function() {
        return self.buildRoute("cscgrn/");
    };

    this.getCSCPRGLink = function() {
        return self.buildRoute("cscproductgroups/");
    };

    this.getInterfaceLink = function() {
        return self.buildRoute("cscinterface/");
    };

    this.canViewRFQC = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().rfxAvailable;
    };

    this.getCatalogRelationLink = function() {
        return self.buildRoute("csccatalogrelation/");
    };

    this.buildRoute = function (route) {
        route = route + selectedListItems.getFirstSelectedId();
        if ($routeParams.preSetId) {
            route = route + "/" + $routeParams.preSetId;
        }
        return route;
    };

    this.buttonDefinition = [
        {label: "mainData", linkFunction: self.getMainDataLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'ViewCSC'},
        {label: "settingsData", linkFunction: self.getSettingsDataLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'ViewCSC'},
        {label: "conditions", linkFunction: self.getConditionsDataLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditCSCConditions'},
        {label: "orders", linkFunction: self.getCSCOrdersLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditCSCOrders'},
        {label: "budgets", linkFunction: self.getCSCBudgetsLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditCSCBudgets'},
        {label: "cscaccounting", linkFunction: self.getAccountingLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditCSCAccounting'},
        {label: "csctolerance", linkFunction: self.getCSCToleranceLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditCSCTolerance'},
        {label: "cscgrn", linkFunction: self.getCSCGrnLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditCSCGrn'},
        {label: "numberingSchemas", linkFunction: self.getCSCNumberingSchemaLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditCSCNumberingSchemas'},
        {label: "outlets", linkFunction: self.getCSCOutletLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditCSCOutlets'},
        {label: "addresses", linkFunction: self.getCSCAddressesLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditCSCAddresses'},
        {label: "comments", linkFunction: self.getCSCCommentsLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditCSCComments'},
        {label: "productgroups", linkFunction: self.getCSCPRGLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditCSCProductGroups'},
        {label: "interface", linkFunction: self.getInterfaceLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'ViewCSC'},
        {label: "rfqc", linkFunction: self.getRFQCDataLink, type:'link', condition:  self.canViewRFQC, process: 'ViewCSC'},
        {label: "catalogRelation", linkFunction: self.getCatalogRelationLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'ViewCSC'}
    ];
}